module.exports = __webpack_public_path__ + "static/media/20.1cbeded1.jpg";